<template>
  <div class="wrapper__create-new-criteria">
    <modal-create-or-update-ultimate-learning-outcome
      v-if="!learningOutcome"
      :learning-unit-id="learningUnitId"
      :show.sync="showModalCreateUltimateLo"
    >
    </modal-create-or-update-ultimate-learning-outcome>

    <BaseModal
      id="ModalCreateNewCrtieria"
      :show.sync="$show"
      title="Learning outcomes"
      size="lg"
      @closeModal="hide"
    >
      <div v-if="!learningOutcome">
        <p class="mb-0 text-black-50 text__no-lo">No learning outcomes</p>
      </div>

      <learning-outcome-tree
        v-else
        :learning-unit-id="learningUnit.id"
        :learning-outcome="learningOutcome"
        :modal-mode="true"
        class="mb-4"
        @onCriteriaDeleted="onCriteriaDeleted"
        @onSubLearningOutcomeDeleted="onSubLearningOutcomeDeleted"
      ></learning-outcome-tree>

      <template #modal-footer>
        <div v-if="!learningOutcome">
          <b-button
            class="btn btn-first button__create-ultimate-lo"
            variant="primary"
            @click="onCreateLearningOutcome"
          >
            Create an ultimate learning outcome
          </b-button>
        </div>

        <b-button v-else variant="outline-primary" style="z-index: 1" @click="goSelectCriterion">
          Select existing criterion
        </b-button>
      </template>
    </BaseModal>
  </div>
</template>

<script>
import { BaseModal } from '@/components/base-components';
import Criteria from '@/models/Criteria';
import LearningUnit from '@/models/LearningUnit';
import LearningOutcome from '@/models/LearningOutcome';
import LearningOutcomeTree from '@/components/LearningOutcome/LearningOutcomeTree';
import ModalCreateOrUpdateUltimateLearningOutcome from '@/components/LearningOutcome/ModalCreateOrUpdateUltimateLearningOutcome';

export default {
  components: {
    BaseModal,
    LearningOutcomeTree,
    ModalCreateOrUpdateUltimateLearningOutcome
  },

  model: {
    prop: 'selectedCriteria',
    event: 'change'
  },

  props: {
    show: {
      type: [Boolean, Number],
      default: false
    },

    learningUnitId: {
      type: [Number, String],
      required: true
    },

    learningOutcome: {
      type: LearningOutcome,
      default: null
    },

    selectedCriteria: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      showModalCreateUltimateLo: false
    };
  },

  computed: {
    $show: {
      get() {
        return this.show;
      },

      set(v) {
        this.$emit('update:show', v);
      }
    },

    learningUnit() {
      return LearningUnit.query().with('ultimate_learning_outcome').find(this.learningUnitId);
    },

    criterias() {
      return Criteria.query().whereId(this.learningOutcome.criterion_ids).get();
    },

    subLearningOutcomes() {
      return LearningOutcome.query().whereId(this.learningOutcome.sub_learning_outcome_ids).get();
    },

    criteriaSubLearningOutcomes() {
      let criterion_ids = [],
        criterions = {};
      this.subLearningOutcomes.map((subLearningOutcome) =>
        criterion_ids.push(...subLearningOutcome.criterion_ids)
      );
      Criteria.query()
        .whereId(criterion_ids)
        .get()
        .map((criterion) => (criterions[criterion.id] = criterion));
      return criterions;
    }
  },

  methods: {
    hide() {
      this.showModalCreateUltimateLo = false;

      this.$show = false;
    },

    goSelectCriterion() {
      this.$emit('onSelectCriterion', true);

      this.hide();
    },

    async onSubmit(data) {
      return await LearningOutcome.api().createUltimateLearningOutcome(this.learningUnitId, data);
    },

    onCreateLearningOutcome() {
      this.showModalCreateUltimateLo = true;
    },

    onCancelCreateUltimateLo() {
      this.showModalCreateUltimateLo = false;
    },

    onCriteriaDeleted(criteria_id) {
      const { selectedCriteria } = this;

      this.$emit(
        'update:selectedCriteria',
        selectedCriteria.filter((id) => id !== criteria_id).filter(Boolean)
      );
    },

    onSubLearningOutcomeDeleted(criteria_ids) {
      const { selectedCriteria } = this;

      this.$emit(
        'update:selectedCriteria',
        selectedCriteria.filter((id) => !criteria_ids.includes(id)).filter(Boolean)
      );
    }
  }
};
</script>
